"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESupportRequestType = void 0;
var ESupportRequestType;
(function (ESupportRequestType) {
    ESupportRequestType["BUG"] = "B";
    ESupportRequestType["FEATURE"] = "F";
    ESupportRequestType["SUPPORT"] = "S";
})(ESupportRequestType = exports.ESupportRequestType || (exports.ESupportRequestType = {}));
;
